import { render, staticRenderFns } from "./ListTStock.vue?vue&type=template&id=8cd113b2&"
import script from "./ListTStock.vue?vue&type=script&lang=js&"
export * from "./ListTStock.vue?vue&type=script&lang=js&"
import style0 from "./ListTStock.vue?vue&type=style&index=0&id=8cd113b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports